module.exports = __webpack_public_path__ + "static/media/curr_mask.98717905.png";